import React, { useState, useEffect } from 'react';

const AudioEditionSelector = ({ selectedEdition, setSelectedEdition, isPlayingAll, togglePlayAll, isPaused, togglePause }) => {
    const [editions, setEditions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEditions = async () => {
            try {
                const response = await fetch('https://api.alquran.cloud/v1/edition');
                const data = await response.json();

                if (data.code === 200 && data.data) {
                    // Filter Arabic audio editions
                    const audioEditions = data.data.filter(
                        edition => edition.language === 'ar' && edition.format === 'audio'
                    );
                    setEditions(audioEditions);


                }
            } catch (err) {
                setError('Failed to fetch audio editions');
                console.error('Error fetching editions:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchEditions();
    }, []);

    const handleEditionChange = (e) => {
        const editionIdentifier = e.target.value;
        setSelectedEdition(editionIdentifier);
        localStorage.setItem('audioEdition', editionIdentifier);
        // You might want to trigger audio player update here
    };

    if (loading) return <div>Loading audio editions...</div>;
    if (error) return <div>{error}</div>;
    if (editions.length === 0) return <div>No Arabic audio editions available</div>;

    return (
        <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
            <select
                id="audioEdition"
                value={selectedEdition}
                onChange={handleEditionChange}
                className="edition-select"
                style={{ flex: 1 }}
            >
                {editions.map((edition) => (
                    <option key={edition.identifier} value={edition.identifier}>
                        {edition.name}
                    </option>
                ))}
            </select>
            <div style={{ display: 'flex', gap: '5px' }}>
                {isPlayingAll && (
                    <button
                        className="pause-button"
                        onClick={togglePause}
                        title={isPaused ? "استئناف" : "إيقاف مؤقت"}
                        style={{ padding: '5px 10px' }}
                    >
                        {isPaused ? '▶️' : '⏸️'}
                    </button>
                )}
                <button
                    id="playAllButton"
                    className="play-all-button"
                    onClick={togglePlayAll}
                    title={isPlayingAll ? "إيقاف" : "تشغيل الكل"}
                >
                    {isPlayingAll ? '⏹' : '▶'}
                </button>
            </div>
        </div>

    );
};

export default AudioEditionSelector;